export default __webpack_public_path__ + "static/media/Reader's Armbands of the Effulgent Blade.781481d2.jpg";